let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kDbiT")).then(() => parcelRequire('77vyI'));